export default __webpack_public_path__ + "static/media/umbrella-with-rain-drops.6aa9b6e7.png";